import React from "react";

const MobileFloatingCTA = ({ onGetStarted }) => {
  return (
    <button
      onClick={onGetStarted}
      className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50 px-8 py-3 rounded-full text-base font-semibold text-white bg-green-500 hover:bg-green-600 shadow-lg transition-all duration-200 hover:scale-105 md:hidden"
      style={{ boxShadow: '0 8px 32px rgba(0,0,0,0.12)' }}
    >
      Start for Free
    </button>
  );
};

export default MobileFloatingCTA;

